<template>
  <div>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="assemblies"
        :search="search"
        :loading="loadingTable"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.name_as }}</td>
          <td class="text-xs-center">
            <v-checkbox
              color="primary"
              class="center"
              :input-value="props.item.status == 0"
              @click="handleStatusChange(props.item.id, props.item.status)"
            >
            </v-checkbox>
          </td>
          <td class="text-xs-center">
            <v-tooltip top v-show="others.is_external==0">
              <v-icon
                medium
                class="mr-2"
                @click="addItem(props.item)"
                slot="activator"
              >
                add
              </v-icon>
              <span>Añadir agenda</span>

            </v-tooltip>
            <!-- <v-tooltip top>
              <v-icon
                medium
                class="mr-2"
                @click="requestSchedule(props.item)"
                slot="activator"
              >
                calendar_today
              </v-icon>
              <span>Solicitar agenda</span>

            </v-tooltip> -->
            <v-tooltip top v-show="others.is_external==0">
              <v-icon
                medium
                class="mr-2"
                @click="takeScheduleAssistance(props.item)"
                slot="activator"
              >
                assignment_turned_in
              </v-icon>
              <span>Tomar asistencia</span>

            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </div>

</template>
<script>
    import axios from 'axios'
    import Form from 'vform';

    export default {
        name: 'quotes-responsible-show',
        data() {
            return {
                others:[],
                search: '',
                headers: [
                    { text: 'Descripcion', align: 'center', value: 'description' },
                    { text: 'Responsable', align: 'center', value: 'responsable_name' },
                    { text: 'Nombre para mostrar', align: 'center', value: 'name_as' },
                    { text: 'Activo', align: 'center', value: 'status' },
                    { text: 'Acción', align: 'center', value: 'id', sortable: false }
                ],
                assemblies: [],
                dialogIdAssembly: 0,
                dialog: false,
                userNameMaxLength: 60,
                entries: [],
                isLoading: false,
                currentMemberSearch: null,
                searchBoardMembers: null,
                boardMembersHeaders: [
                    { text: 'Actions', value: 'name', sortable: false, align: 'center' }
                ],
                boardMembers: [],
                boardMembersSearch: '',
                showCreateMemberForm: false,
                createMemberForm: new Form({
                    name: ''
                }),
                loadingTable: false,
            }
        },
        created() {
            this.getShow()
        },
        methods: {
            async getShow() {
                this.loadingTable = true;
                const { data } = await axios.get('/api/quotes/responsable/show/admin')
                this.assemblies = data.data;
                this.others = data.others[0]
                console.log(data.others[0])
                this.loadingTable = false;
            },
            addItem(item) {
                this.$router.push({ name: 'shedule.create', params: {id: item.id}});
            },
            requestSchedule(item) {
                this.$router.push({ name: 'shedule.RequestSchedule', params: {id: item.id}});
            },
            takeScheduleAssistance(item) {
                this.$router.push({ name: 'shedule.ScheduleTakeAssistance', params: {id: item.id}});
            },
            handleStatusChange(id, status) {
              const newStatus = status == -1 ? 0 : -1
              axios.put('/api/responsable/change/status', {id, newStatus})
                .then(resp => {
                  if (resp.status === 200) {
                    this.getShow()
                  }
                })
                .catch(err => console.log(err))
            }
        }
    }
</script>
<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/responsibleAppointment/showResponsibleQuoteAdmin.vue